import React from "react";
import { Link } from "react-router-dom";
import { t } from "i18next";

function NoUserAd({ headerText, contentText }) {
    return (
        <div className="flex flex-col items-center justify-center text-center py-16 px-6">
            <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
            </div>
            <h2 className="text-base font-semibold text-gray-800 mb-1">{headerText}</h2>
            <p className="text-sm text-gray-400 max-w-xs mx-auto mb-6 leading-relaxed">{contentText}</p>
            <Link to="/adform">
                <button className="bg-[#147F26] hover:bg-[#0f5f1a] text-white text-sm font-semibold py-2.5 px-6 rounded-xl transition-colors">
                    {t('createAnnouncement')}
                </button>
            </Link>
        </div>
    );
}

export default NoUserAd;
